/**
 * Activate sticky header bar
 */
export const initSticky = (md) => {
    if (!md.phone() && !md.tablet()) {
        $(window).scroll(makeSticky);
    }
};

const makeSticky = () => {
    let gap = $('.site-header__logo').outerHeight();
    let header = $('.site-header');
    let layout = $('body');
    if ($(window).scrollTop() >= gap /*.outerHeight()*/ ) {
        header.addClass('site-header--is-stuck');
        layout.addClass('is-stuck');
    } else {
        header.removeClass('site-header--is-stuck');
        layout.removeClass('is-stuck');
    }
};